import type { Neighborhood, SimpleNeighborhood } from "@/types/neighborhood";

export const getNeighborhoodDisplay = (
  neighborhood: Neighborhood | SimpleNeighborhood | string | null | undefined
): string => {
  if (!neighborhood) return 'Not specified';
  if (typeof neighborhood === 'string') return neighborhood;
  if ('name' in neighborhood && neighborhood.name) return neighborhood.name;
  return 'Not specified';
};

export const getLocationDisplay = (
  neighborhood: Neighborhood | SimpleNeighborhood | string | null | undefined
): string => {
  if (!neighborhood || typeof neighborhood === 'string') {
    return 'New York City';
  }

  if ('city' in neighborhood && neighborhood.city) {
    return `${neighborhood.city.name}, ${neighborhood.city.state}`;
  }

  return 'New York City';
};

export const formatNeighborhoodName = (name: string): string => {
  return name.split('-').map(word => 
    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  ).join(' ');
};